import React from 'react';
import { Button, Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

interface Props {  
  viewUrl?: string;
  editUrl?: string;
  viewClick?: () => void;
  editClick?: () => void;
  onDelete?: () => void;
}

const TableActionButtons: React.FC<Props> = ({ viewUrl, editUrl, onDelete, viewClick, editClick }) => {
  return (
    <Space size="middle">
      {viewUrl && (
        <Link to={viewUrl} title="View">
          <FontAwesomeIcon
            icon={faEye}
            className="text-gray-600 hover:text-gray-800 cursor-pointer"
          />
        </Link>
      )}
      {viewClick && (
        <span title="View" onClick={viewClick}>
          <FontAwesomeIcon
            icon={faEye}
            className="text-gray-600 hover:text-gray-800 cursor-pointer"
          />
        </span>
      )}
      {editUrl && (
        <Link to={editUrl} title="Edit">
          <FontAwesomeIcon
            icon={faEdit}
            className="text-gray-600 hover:text-gray-800 cursor-pointer"
          />
        </Link>
      )}
      {editClick && (
        <span title="Edit" onClick={editClick}>
          <FontAwesomeIcon
            icon={faEdit}
            className="text-gray-600 hover:text-gray-800 cursor-pointer"
          />
        </span>
      )}
      {onDelete && (
        <Popconfirm title="Confirm delete?" onConfirm={onDelete}>
          <span title="Delete">
            <FontAwesomeIcon
              icon={faTrash}
              className="text-red-600 hover:text-red-800 cursor-pointer"
            />
          </span>
        </Popconfirm>
      )}
    </Space>
  );
};

export default TableActionButtons;
